<h2 class="mb-2">{{ 'billingAddressEditTitle' | commonBillingWording | async }}</h2>
<yat-billing-address-form
  [editedBillingAddress]="(editedBillingAddress$ | async) ?? {}"
  [countries]="(countries$ | async) ?? []"
  (save)="save($event)"
  (cancelMethod)="cancel()"
  buttonsClassName="btn-large"
  [businessModel]="(businessModel$ | async) ?? 'B2B'">
</yat-billing-address-form>
